// extracted by mini-css-extract-plugin
export default {"body":"TemplateNameModal_body__lanSs","nameInput":"TemplateNameModal_nameInput__Ca+QS","submitButton":"TemplateNameModal_submitButton__u7IZm"};